import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { KeyValue } from '@/main/models/common';
import { IntegrationInterfaceResponse } from '../../models/response';
import { IntegrationQueueServiceRequest } from '@/main/models/request';

export abstract class IIntegrationApi {
  abstract getIntegrIntegrationInterfacesByGuidIntegration(
    request: IntegrationQueueServiceRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;

  abstract getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>>;

  abstract getDomainIntegrationType(): Promise<
    AxiosResponse<Result<KeyValue[]>>
  >;

  abstract getDomainService(
    idIntegrationType: number
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;

  abstract getIntegrationIntegrationInterfaces(
    guidIntegrationInterface: string | null
  ): Promise<AxiosResponse<Result<KeyValue[]>>>;

  abstract getIntegrationInterface(
    guidIntegration: string,
    idIntegrationType: number
  ): Promise<AxiosResponse<Result<IntegrationInterfaceResponse[]>>>;
}
